/* eslint-disable react/prop-types,no-undef */
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LinkedIn } from 'react-linkedin-login-oauth2';
import { Button } from '@material-ui/core';
import loginStyles from 'assets/jss/icw/loginStyle';
import linkedInLogo from 'assets/img/linkedin.svg';
import { withStyles } from '@material-ui/styles';
import { LINKEDIN_REDIRECT_PATH, LINKEDIN_PATHNAME_TYPES } from 'shared/constants';
import { getLocale } from 'util/icwUtility';
import { userGetLinkedinInfo } from 'views/Login/actions';

const LinkedInButton = ({
  getLinkedinInfo,
  pathname = LINKEDIN_PATHNAME_TYPES.login,
  classes,
  title,
  onSuccess,
  onError,
}) => {
  const redirectUri = useMemo(
    () => window.location.href.split(pathname)[0] + LINKEDIN_REDIRECT_PATH,
    [window]
  );

  const linkedinPopupPath = `/${getLocale()}/${LINKEDIN_REDIRECT_PATH}`;

  const handleSuccess = (data) => {
    const { code = '' } = data;
    if (!code) return;

    getLinkedinInfo({ code, redirectUrl: redirectUri }, (res) => {
      const { id = null, emailAddress = null } = res;
      if (!id) return;

      if (onSuccess) {
        onSuccess({ id, email: emailAddress });
      }
    });
  };

  const handleFailure = (error) => {
    if (onError) {
      onError(error);
    }
  };

  return (
    <LinkedIn
      clientId={process.env.REACT_APP_LINKED_IN_ID}
      redirectUri={redirectUri}
      scope='r_liteprofile r_emailaddress'
      onSuccess={handleSuccess}
      onFailure={handleFailure}
      renderElement={({ onClick, disabled }) => (
        <Button
          onClick={onClick}
          disabled={disabled}
          variant='outlined'
          className={classes.linkedInButton}
          startIcon={<img src={linkedInLogo} alt='linkedin' />}>
          {title}
        </Button>
      )}
      supportIE
      redirectPath={linkedinPopupPath}
    />
  );
};

const mapDispatchToProps = (dispatch) => ({
  getLinkedinInfo: bindActionCreators(userGetLinkedinInfo, dispatch),
});

export default connect(null, mapDispatchToProps)(withStyles(loginStyles)(LinkedInButton));
